import React, { FC } from 'react'

import { Typography, FNOLButton, useTranslate, FNOLPageWrapper } from '@dg-shared'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { Events } from '../../../FSM/shared/constants'
import { TRANSLATIONS as T } from '../../../constants'
import { useFNOLStyles } from '../shared/styles/useStyles'

const PageInjured: FC<CommonPageProps> = ({ service, currentState }) => {
  const FNOLClasses = useFNOLStyles({})
  const { t } = useTranslate(`${T.COLLISION}.injured`)
  const { send } = service

  const itemSelect = ({ eventName, label }: { eventName: Events; label: string }) => (
    <FNOLButton
      key={label}
      handleClick={() => send({ type: eventName, state: currentState })}
      buttonText={t(label)}
      testId={label}
    />
  )

  const eventItems = [
    { eventName: Events.FNOL_COLLISION_CASE_OF_ACCIDENT, label: 'buttons.noOne' },
    { eventName: Events.FNOL_COLLISION_MORE_DETAILS, label: 'buttons.inMyCar' },
    { eventName: Events.NEXT, label: 'buttons.inAnotherCar' },
  ]

  const ItemsList = () => <>{eventItems.map((item) => itemSelect(item))}</>

  const Content = () => (
    <>
      <Typography testId='title' type='h1' className={FNOLClasses.title}>
        {t('title')}
      </Typography>
      <Typography testId='subtitle' html={true} className={FNOLClasses.description}>
        {t('subtitle')}
      </Typography>
      <ItemsList />
    </>
  )

  return (
    <FNOLPageWrapper breadcrumbsBtnText={t(`${T.COMMON}/back`)} breadcrumbsStepPercentage={40}>
      <Content />
    </FNOLPageWrapper>
  )
}

export default PageInjured
